// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8809 ? "700d6c82" : chunkId) + "." + {"1510":"f235add238e351d2","6127":"ab4b6510c08303d6","7161":"68568a0f68cb74cc","8083":"4315216ea70774a2","8809":"933570196ff36bd0"}[chunkId] + ".js";
};